import React from 'react'
import ContactForm from '../../components/ContactForm'
 
export default function Contact() {
    document.title = "Contact Us";
    return (
            <div>
                <ContactForm />
            </div>
            )}